export default {
    scheduled_reports_report_name: "Report Name",
    scheduled_reports_report_type: "Report Type",
    scheduled_reports_scheduled_at: "Scheduled At",
    scheduled_reports_completed_on: "Completed On",
    scheduled_reports_format: "Format",
    scheduled_reports_send_by_email: "Send By Email",
    scheduled_reports_status: "Status",
    scheduled_reports_args_path: "Args Path",
    scheduled_reports_params: "Params",
    scheduled_reports_emails: "Emails",
    scheduled_reports_yes: "Yes",
    scheduled_reports_no: "No",
    scheduled_show_params: "Show Params",
    scheduled_download_report: "Download Report",
    scheduled_no_data_available: "No Data Available",
    scheduled_created_on: "Created On",
    scheduled_last_process_update: "Last Process Update",
    scheduled_error: "Error",
    scheduled_account: "Account",
}